"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULTS = exports.DEFAULT_CLAIMS = exports.ERROR_CODES = exports.AUTHENTICATOR_TYPES = exports.MTID = exports.AUTO_LOGIN_TIMESTAMP_COOKIE = exports.MSC_OIDC_RETURN_TO = exports.AUTHENTICATION_CONTEXT_ID = exports.MANUAL_LOGIN_TIMEOUT = exports.MANUAL_LOGIN_TIMESTAMP_COOKIE = void 0;
exports.MANUAL_LOGIN_TIMESTAMP_COOKIE = 'msc-authenticator-last-manual-login-timestamp';
exports.MANUAL_LOGIN_TIMEOUT = 1000 * 60 * 60; // 1 hour in ms
exports.AUTHENTICATION_CONTEXT_ID = 'msc-authenticator-acid';
exports.MSC_OIDC_RETURN_TO = 'msc-authenticator-oidc-return-to';
exports.AUTO_LOGIN_TIMESTAMP_COOKIE = 'msc-authenticator-first-auto-login-timestamp';
exports.MTID = 'msc-authenticator-mtid';
var AUTHENTICATOR_TYPES;
(function (AUTHENTICATOR_TYPES) {
    AUTHENTICATOR_TYPES["OIDC"] = "oidc";
    AUTHENTICATOR_TYPES["BACKEND_FOR_FRONTEND"] = "backend-for-frontend";
    AUTHENTICATOR_TYPES["TOKEN_PROVIDER"] = "token-provider";
})(AUTHENTICATOR_TYPES || (exports.AUTHENTICATOR_TYPES = AUTHENTICATOR_TYPES = {}));
var ERROR_CODES;
(function (ERROR_CODES) {
    ERROR_CODES[ERROR_CODES["LOGIN_SETUP_FAILED"] = 100] = "LOGIN_SETUP_FAILED";
    ERROR_CODES[ERROR_CODES["AUTOLOGIN_FAILED"] = 101] = "AUTOLOGIN_FAILED";
})(ERROR_CODES || (exports.ERROR_CODES = ERROR_CODES = {}));
exports.DEFAULT_CLAIMS = {
    userinfo: {
        tracking_id: null,
        preferred_username: null,
        given_name: null,
        family_name: null,
    },
};
exports.DEFAULTS = {
    authority: 'https://test-login.migros.ch',
    clientId: '',
    clientSecret: '',
    loginUrl: '',
    redirectURI: '',
    silentRedirectURI: '',
    responseType: 'code',
    scope: 'openid',
    claims: exports.DEFAULT_CLAIMS,
    includeIdTokenInSilentRenew: true,
    language: 'de',
};
